
namespace Matrix.Data {

    @Serenity.Decorators.registerEditor()
    export class UrlTargetEditor extends Serenity.Select2Editor<any, any> {

        constructor(element: JQuery) {
            super(element, { autoComplete: true });

            this.addOption("_blank", "_blank");
        }
    }
}